import axios, { AxiosRequestConfig, AxiosResponse } from "axios"
import { windowLock, windowRelease } from "../utils/loader"
import { NotificationService } from "../features/NotificationService/NotificationService"

const handleUnauthorized = (e: any) => {
  if (e?.response?.status === 401) {
    localStorage.removeItem("token")
    if (location.pathname !== "/login") {
      location.replace("/login")
    }
  }
}

export class SysApi {
  public static baseUrl = "/"

  protected static async post<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>,
    withLockWindow = true,
  ): Promise<R> {
    const token = localStorage.getItem("token")
    if (!token) {
      location.replace("/login")
      throw new Error("Пользователь не авторизирован")
    }
    if (withLockWindow) {
      windowLock()
    }
    try {
      const res = await axios.post<T>(url, data, {
        ...config,
        headers: {
          ...config?.headers,
          Authorization: `Bearer ${token}`,
        },
      })

      if (withLockWindow) {
        windowRelease()
      }
      return res as R
    } catch (e: any) {
      if (withLockWindow) {
        windowRelease()
      }
      handleUnauthorized(e)
      NotificationService.showNotification({
        level: "error",
        message:
          e?.response?.data?.message ||
          "Произошла ошибка при обращении к серверу, обратитесь к администратору",
        errorBody:
          (e?.response?.data?.error &&
            JSON.stringify(e?.response?.data?.error)) ||
          e?.response?.data?.e ||
          JSON.stringify(e),
      })
      throw e
    }
  }
  protected static async put<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>,
    withLockWindow = true,
  ): Promise<R> {
    const token = localStorage.getItem("token")
    if (!token) {
      location.replace("/login")
      throw new Error("Пользователь не авторизирован")
    }
    if (withLockWindow) {
      windowLock()
    }
    try {
      const res = await axios.put<T>(url, data, {
        ...config,
        headers: {
          ...config?.headers,
          Authorization: `Bearer ${token}`,
        },
      })

      if (withLockWindow) {
        windowRelease()
      }
      return res as R
    } catch (e: any) {
      if (withLockWindow) {
        windowRelease()
      }
      handleUnauthorized(e)
      NotificationService.showNotification({
        level: "error",
        message:
          e?.response?.data?.message ||
          "Произошла ошибка при обращении к серверу, обратитесь к администратору",
        errorBody: e?.response?.data?.e || JSON.stringify(e),
      })
      throw e
    }
  }
  protected static async get<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>,
    withLockWindow = true,
  ): Promise<R> {
    const token = localStorage.getItem("token")
    if (!token) {
      location.replace("/login")
      throw new Error("Пользователь не авторизирован")
    }
    if (withLockWindow) {
      windowLock()
    }
    try {
      const res = await axios.get<T>(url, {
        ...config,
        headers: {
          ...config?.headers,
          Authorization: `Bearer ${token}`,
        },
      })
      if (withLockWindow) {
        windowRelease()
      }

      return res as R
    } catch (e: any) {
      if (withLockWindow) {
        windowRelease()
      }
      handleUnauthorized(e)
      NotificationService.showNotification({
        level: "error",
        message:
          e?.message ||
          "Произошла ошибка при обращении к серверу, обратитесь к администратору",
        errorBody: JSON.stringify(e),
      })
      throw e
    }
  }
  protected static async delete<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>,
    withLockWindow = true,
  ): Promise<R> {
    const token = localStorage.getItem("token")
    if (!token) {
      location.replace("/login")
      throw new Error("Пользователь не авторизирован")
    }
    if (withLockWindow) {
      windowLock()
    }
    try {
      const res = await axios.delete<T>(url, {
        ...config,
        headers: {
          ...config?.headers,
          Authorization: `Bearer ${token}`,
        },
      })
      if (withLockWindow) {
        windowRelease()
      }
      return res as R
    } catch (e: any) {
      if (withLockWindow) {
        windowRelease()
      }
      handleUnauthorized(e)
      NotificationService.showNotification({
        level: "error",
        message:
          e?.message ||
          "Произошла ошибка при обращении к серверу, обратитесь к администратору",
        errorBody: JSON.stringify(e),
      })
      throw e
    }
  }

  // Унифицированный результат авторизации: успех всегда несёт токен,
  // провал — сообщение. Раньше возвращалось "ok" | data (разные типы).
  static async auth(data: {
    username: string
    password: string
  }): Promise<{ success: boolean; token?: string; message?: string }> {
    try {
      const { data: res } = await axios.post(this.baseUrl + "api/login", data)
      if (res?.success) {
        localStorage.setItem("token", res.token)
        location.replace("/")
        return { success: true, token: res.token }
      }
      return { success: false, message: res?.message }
    } catch (e: any) {
      return {
        success: false,
        message:
          e?.response?.data?.message ||
          e?.message ||
          "Ошибка сети при авторизации",
      }
    }
  }
}
